export default __webpack_public_path__ + "static/media/403.47b54f23.jpg";